import { ProviderBalanceGroup } from '@leagueplatform/wallet-api';

export const networkHasTiers = (providerServices: ProviderBalanceGroup[]) =>
  providerServices.some((service) => service.provider);
